import React, { useState, useEffect } from 'react';
import './CookieConsent.css';

const COOKIE_KEY = 'asuma_cookie_consent';

export default function CookieConsent() {
  const [visible, setVisible] = useState(false);
  const [showDetails, setShowDetails] = useState(false);
  const [preferences, setPreferences] = useState({
    necessary: true,
    analytics: true,
    marketing: false,
  });

  useEffect(() => {
    const stored = localStorage.getItem(COOKIE_KEY);
    if (!stored) {
      const timer = setTimeout(() => setVisible(true), 1200);
      return () => clearTimeout(timer);
    }
  }, []);

  const handleAcceptAll = () => {
    const consent = { necessary: true, analytics: true, marketing: true, timestamp: Date.now() };
    localStorage.setItem(COOKIE_KEY, JSON.stringify(consent));
    setVisible(false);
  };

  const handleRejectAll = () => {
    const consent = { necessary: true, analytics: false, marketing: false, timestamp: Date.now() };
    localStorage.setItem(COOKIE_KEY, JSON.stringify(consent));
    setVisible(false);
  };

  const handleSavePreferences = () => {
    const consent = { ...preferences, necessary: true, timestamp: Date.now() };
    localStorage.setItem(COOKIE_KEY, JSON.stringify(consent));
    setVisible(false);
  };

  if (!visible) return null;

  return (
    <div className="cookie-overlay">
      <div className="cookie-banner">
        <div className="cookie-header">
          <span className="cookie-icon">🍪</span>
          <h3>Cookie & Cache Preferences</h3>
        </div>

        <p className="cookie-text">
          We use cookies and local storage to enhance your experience, analyse site traffic, and personalise content. 
          You can choose which cookies to allow below. See our <a href="/cookie-policy.html" target="_blank" rel="noopener noreferrer" style={{ color: '#1890ff', textDecoration: 'underline' }}>Cookie Policy</a>.
        </p>

        {showDetails && (
          <div className="cookie-details">
            <label className="cookie-option">
              <input type="checkbox" checked disabled />
              <div>
                <strong>Necessary</strong>
                <span>Required for the site to function. Cannot be disabled.</span>
              </div>
            </label>
            <label className="cookie-option">
              <input
                type="checkbox"
                checked={preferences.analytics}
                onChange={(e) => setPreferences(p => ({ ...p, analytics: e.target.checked }))}
              />
              <div>
                <strong>Analytics & Performance</strong>
                <span>Help us understand how visitors interact with the site.</span>
              </div>
            </label>
            <label className="cookie-option">
              <input
                type="checkbox"
                checked={preferences.marketing}
                onChange={(e) => setPreferences(p => ({ ...p, marketing: e.target.checked }))}
              />
              <div>
                <strong>Marketing</strong>
                <span>Used to deliver relevant ads and track campaigns.</span>
              </div>
            </label>
          </div>
        )}

        <div className="cookie-actions">
          <button className="cookie-btn cookie-btn-ghost" onClick={handleRejectAll}>
            Reject All
          </button>
          <button
            className="cookie-btn cookie-btn-outline"
            onClick={() => showDetails ? handleSavePreferences() : setShowDetails(true)}
          >
            {showDetails ? 'Save Preferences' : 'Manage Preferences'}
          </button>
          <button className="cookie-btn cookie-btn-primary" onClick={handleAcceptAll}>
            Accept All
          </button>
        </div>

        <p className="cookie-footer">
          By clicking "Accept All", you agree to our <a href="/privacy-policy.html" target="_blank" rel="noopener noreferrer">Privacy Policy</a>.
        </p>
      </div>
    </div>
  );
}
